import { Turnstile } from "@marsidev/react-turnstile";
import "./contact_view.css";
import TitlePage from "../../../core/components/title_pages/title_pages.jsx";
import Loading from "../../../core/components/loading/loading.jsx";
import { contactMapper } from "../utils/mapper/contact_mapper.jsx";
import { useContactViewModel } from "../view_model/contact_view_model.jsx";

const ContactView = () => {
  const {
    form,
    errors,
    isLoading,
    captchaToken,
    handleChange,
    handleSubmit,
    handleCaptchaSuccess,
    handleCaptchaExpire,
    handleCaptchaError,
  } = useContactViewModel();

  return (
    <div className="contact">
      <div className="container">
        <TitlePage title={contactMapper.title} />
        <div className='container_contact'>
          <div className='contact_title'>
            <h1>{contactMapper.formTitle}</h1>
          </div>
          <div className='contact_form'>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                {errors.name && (
                  <span className="contact_form_error" role="alert">{errors.name}</span>
                )}
                <input
                  type={contactMapper.formFields.name.type}
                  className={`form-control ${errors.name ? 'form-control--error' : ''}`}
                  id={contactMapper.formFields.name.id}
                  placeholder={contactMapper.formFields.name.placeholder}
                  value={form.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  disabled={isLoading}
                />
              </div>
              <div className="mb-3">
                {errors.email && (
                  <span className="contact_form_error" role="alert">{errors.email}</span>
                )}
                <input
                  type={contactMapper.formFields.email.type}
                  className={`form-control ${errors.email ? 'form-control--error' : ''}`}
                  id={contactMapper.formFields.email.id}
                  placeholder={contactMapper.formFields.email.placeholder}
                  value={form.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  disabled={isLoading}
                />
              </div>
              <div className="mb-3">
                {errors.message && (
                  <span className="contact_form_error" role="alert">{errors.message}</span>
                )}
                <textarea
                  className={`form-control ${errors.message ? 'form-control--error' : ''}`}
                  id={contactMapper.formFields.message.id}
                  rows={contactMapper.formFields.message.rows}
                  placeholder={contactMapper.formFields.message.placeholder}
                  value={form.message}
                  onChange={(e) => handleChange('message', e.target.value)}
                  disabled={isLoading}
                />
              </div>

              <div className="contact_form_captcha">
                <Turnstile
                  siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                  onSuccess={handleCaptchaSuccess}
                  onExpire={handleCaptchaExpire}
                  onError={handleCaptchaError}
                  options={{
                    theme: "auto",
                    size: "normal"
                  }}
                />
              </div>

              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-primary contact_form_submit"
                  disabled={isLoading || !captchaToken}
                >
                  {isLoading ? (
                    <Loading color="#000" size={22} text="Enviando..." ariaLabel="Enviando" />
                  ) : (
                    contactMapper.submitButton
                  )}
                </button>
              </div>
            </form>
            <div className='contact_terms'>
              <p>
                {contactMapper.termsText.split('Termos e Condições')[0]}
                <span className="highlight">Termos e Condições</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactView;
